import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=439ee8fa&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
import style0 from "./Error.vue?vue&type=style&index=0&id=439ee8fa&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439ee8fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('439ee8fa')) {
      api.createRecord('439ee8fa', component.options)
    } else {
      api.reload('439ee8fa', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=439ee8fa&scoped=true", function () {
      api.rerender('439ee8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/result/Error.vue"
export default component.exports